import { EThemeTemplate as e } from "../common/type.mjs";
import { messageThemeMap as r, formThemeMap as t, draggedUploadThemeMap as p, uploadThemeMap as T, tagsThemeMap as m, tabsThemeMap as s, selectThemeMap as u, radioGroupThemeMap as n, popupThemeMap as c, linkThemeMap as h, textAreaThemeMap as M, measureInputThemeMap as o, inputThemeMap as A, checkboxThemeMap as E, balloonThemeMap as O, buttonThemeMap as l } from "../assets/css/themes/template/templateMap.mjs";
const d = (a) => {
  switch (a) {
    case e.BUTTON:
      return l;
    case e.BALLOON:
      return O;
    case e.CHECKBOX:
      return E;
    case e.INPUT:
      return A;
    case e.MEASURE_INPUT:
      return o;
    case e.TEXTAREA:
      return M;
    case e.LINK:
      return h;
    case e.POPUP:
      return c;
    case e.RADIO_GROUP:
      return n;
    case e.SELECT:
      return u;
    case e.TABS:
      return s;
    case e.TAG:
      return m;
    case e.UPLOAD:
      return T;
    case e.DRAGGED_UPLOAD:
      return p;
    case e.FORM:
      return t;
    case e.MESSAGE:
      return r;
  }
};
export {
  d as default
};
//# sourceMappingURL=themeUtil.mjs.map
